import {
  computed,
  ref,
  toRef,
} from "vue";

import {
  filter,
  some,
} from "lodash-es";


export default function CurrentIconsAPI(props, {
  allIcons = ref([]),
}) {
  const model = toRef(props, "model");

  const currentIcons = computed(() => {
    return filter(allIcons.value, oic => some(model.value, el => oic.pk === el));
  });

  return {
    currentIcons,
  };
}
